import React from 'react';

import { theme } from 'antd';

const { useToken } = theme;

const PlusCircleIcon = ({ color, ...rest }: { color?: string; [x: string]: unknown }) => {
  const { token } = useToken();
  return (
    <svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Fallback"
          transform="translate(-1526.000000, -885.000000)"
          fill={color ?? token.colorBorderSecondary}
          fillRule="nonzero"
        >
          <g id="plus-(1)" transform="translate(1526.000000, 885.000000)">
            <path
              d="M20,0 C8.97155766,0 0,8.97155766 0,20 C0,31.0284423 8.97155766,40 20,40 C31.0284423,40 40,31.0284423 40,20 C40,8.97155766 31.0284423,0 20,0 Z M28.75,21.6665649 L21.6665649,21.6665649 L21.6665649,28.75 C21.6665649,29.670105 20.920105,30.4165649 20,30.4165649 C19.079895,30.4165649 18.3334351,29.670105 18.3334351,28.75 L18.3334351,21.6665649 L11.25,21.6665649 C10.329895,21.6665649 9.58343508,20.920105 9.58343508,20 C9.58343508,19.079895 10.329895,18.3334351 11.25,18.3334351 L18.3334351,18.3334351 L18.3334351,11.25 C18.3334351,10.329895 19.079895,9.58343508 20,9.58343508 C20.920105,9.58343508 21.6665649,10.329895 21.6665649,11.25 L21.6665649,18.3334351 L28.75,18.3334351 C29.670105,18.3334351 30.4165649,19.079895 30.4165649,20 C30.4165649,20.920105 29.670105,21.6665649 28.75,21.6665649 L28.75,21.6665649 Z"
              id="Shape"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default PlusCircleIcon;
